export const routes = {
  // importCandidates: {
  //   path: '/',
  //   title: 'Import Candidates'
  // },
  candidates: {
    path: '/',
    title: 'Candidates'
  },
}